import './back.css';

/**
 * Seta de voltar do app: a ponta firme, o traço que some e um ponto de origem,
 * como um caminho de volta. Usada em todos os botões de voltar (só ícone).
 */
export function BackIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M10.4 5.6 4.6 12l5.8 6.4"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4 12h9.2"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.82"
      />
      <circle cx="19.1" cy="12" r="1.5" fill="currentColor" opacity="0.4" />
    </svg>
  );
}
